import React, { useState } from 'react';
import { SidebarProps as Props } from '../';
import style from '../new.module.scss';
import { DeleteIcon, EditIcon } from '../../../../icons';
import FlowIcon from '../../../../../../../../assets/svg/solo-chat/content-flow.svg';
import MessageIcon from '../../../../../../../../assets/svg/solo-chat/content-chat.svg';
import { NewAction } from './';

export function Actions(props: Props) {
	const { isNewAction, setIsNewAction } = props
	const { actions } = props.dialog;
	const [editActionName, setEditActionName] = useState('');

	function handleDelete(key: string) {
		const newActions = { ...actions };
		delete newActions[key];
		props.selectAction("")
		props.viewMessageResp(false)
		props.updateDialogByKey('actions', newActions);
	}

	return (
		<div className={style.actions}>
			{!isNewAction ? (
				<div className={style.actionHeading}>
					<p>Actions</p>
					<button
						className={style.add}
						onClick={() => {
							props.clearError('actions');
							setIsNewAction(true)
							props.setNewAction({
							 isRandom: false,
							 suggestions: [],
							 messages: []
							})
						}}
					>
						+ Add Actions
					</button>
				</div>
			) : (
				<NewAction {...props} close={() => {
					setIsNewAction(false)
					props.selectAction("")
					props.viewMessageResp(false)
				}} />
			)}
			{Object.keys(actions).length > 0 && (
				<div className={style.actionsList}>
					{Object.keys(actions).map((key) => {
						const action = actions[key];

						if (key === editActionName) {
							return (
								<NewAction
									key={key}
									close={() => {
										props.selectAction("")
										setIsNewAction(false)
										props.viewMessageResp(false);
										setEditActionName('');
									}}
									{...props}
									initialValues={{
										actionName: key,
										nodeId: action.type === 'flow' ? action.nodeId : '',
										flowName: action.type === 'flow' ? action.flowName : '',
										type: action.type,
									}}
								/>
							);
						}

						return (
							<div
								data-selected={props.selectedAction === key}
								role="button"
								onClick={() => {
									if (action.type === 'message') {
										props.selectAction(props.selectedAction === key ? '' : key);
										props.viewMessageResp(
											props.selectedAction === key ? false : true,
										);
									}
								}}
								key={key}
								className={style.actionPreview}
							>
								<div className={style.actionInfo}>
									<img
										src={action.type === 'message' ? MessageIcon : FlowIcon}
										alt="response type"
									/>
									<p>{key}</p>
								</div>
								<div className={style.actionBtns}>
									<button
										onClick={(e) => {
											e.stopPropagation();
											setEditActionName(key);
										}}
									>
										<EditIcon width="14px" height="14px" stroke="#8C9099" />
									</button>
									<button
										onClick={(e) => {
											e.stopPropagation();
											handleDelete(key);
										}}
									>
										<DeleteIcon width="14px" height="14px" stroke="#8C9099" />
									</button>
								</div>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
}
